export default "__VITE_ASSET__Bn6beL4u__"